import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { getEmployees } from "../services/api";
import ProgressBar from "../components/ProgressBar";

export default function EmployeesPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [employees, setEmployees] = useState([]);
  const [search, setSearch] = useState("");
  const awaitingDelete = searchParams.get("awaiting_delete") === "true";
  const [filter, setFilter] = useState({
    missing_ad: searchParams.get("missing_ad") === "true",
    awaiting_delete: awaitingDelete,
    hideInactive: !awaitingDelete, // Inaktive standardmäßig ausblenden, außer bei Offboarding-Queue
  });
  const [loading, setLoading] = useState(true);

  const loadEmployees = () => {
    setLoading(true);
    const params = {
      search,
      missing_ad: filter.missing_ad || undefined,
      awaiting_delete: filter.awaiting_delete || undefined,
      status: filter.hideInactive ? "active" : undefined,
    };
    getEmployees(params)
      .then((res) => setEmployees(res.data.employees || []))
      .catch(console.error)
      .finally(() => setLoading(false));
  };

  useEffect(() => { loadEmployees(); }, [search, filter]);

  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <h1 style={{ fontSize: 28, fontWeight: 700 }}>Mitarbeiter</h1>
        <p style={{ color: "#666", marginTop: 4 }}>{employees.length} Einträge</p>
      </div>

      {/* Filter-Leiste */}
      <div className="card" style={{ marginBottom: 20, display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap" }}>
        <input
          placeholder="Suche nach Name oder E-Mail..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{ flex: 1, minWidth: 200, padding: "8px 12px", borderRadius: 6, border: "1px solid #e1e4e8", fontSize: 14, outline: "none" }}
        />
        <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 14, cursor: "pointer" }}>
          <input type="checkbox" checked={filter.hideInactive} onChange={(e) => setFilter(f => ({ ...f, hideInactive: e.target.checked }))} />
          Nur Aktive
        </label>
        <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 14, cursor: "pointer" }}>
          <input type="checkbox" checked={filter.missing_ad} onChange={(e) => setFilter(f => ({ ...f, missing_ad: e.target.checked }))} />
          Fehlt in Azure AD
        </label>
        <button className="btn-secondary" onClick={loadEmployees}>↻ Aktualisieren</button>
      </div>

      {/* Tabelle */}
      <div className="card" style={{ padding: 0, overflow: "hidden" }}>
        {loading ? (
          <div style={{ padding: 40 }}><ProgressBar label="Lade Mitarbeiter…" /></div>
        ) : employees.length === 0 ? (
          <div style={{ padding: 40, textAlign: "center", color: "#666" }}>Keine Mitarbeiter gefunden</div>
        ) : (
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 14 }}>
              <thead>
                <tr style={{ background: "#f8f9fa", borderBottom: "2px solid #e1e4e8" }}>
                  {["Name", "E-Mail", "Mobil", "Abteilung", "Position", "Azure AD", "Status"].map((h) => (
                    <th key={h} style={{ padding: "12px 16px", textAlign: "left", fontWeight: 600, color: "#444", whiteSpace: "nowrap" }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {employees.map((emp) => (
                  <tr key={emp.id} style={{ borderBottom: "1px solid #f0f0f0", cursor: "pointer" }}
                    onClick={() => navigate(`/employees/${emp.hrlab_id}`)}
                    onMouseOver={(e) => e.currentTarget.style.background = "#f8f9fa"}
                    onMouseOut={(e) => e.currentTarget.style.background = ""}
                  >
                    <td style={{ padding: "10px 16px", fontWeight: 500 }}>
                      {emp.first_name} {emp.last_name}
                    </td>
                    <td style={{ padding: "10px 16px", color: "#555" }}>
                      {emp.ad_upn || emp.email || "—"}
                      {emp.ad_upn && emp.email && emp.ad_upn.toLowerCase() !== emp.email.toLowerCase() && (
                        <div style={{ fontSize: 11, color: "#999" }} title="E-Mail aus HRLab (z.B. private Adresse vor Diensteintritt)">
                          HRLab: {emp.email}
                        </div>
                      )}
                    </td>
                    <td style={{ padding: "10px 16px", color: "#555" }}>{emp.mobile || "—"}</td>
                    <td style={{ padding: "10px 16px", color: "#555" }}>{emp.department || "—"}</td>
                    <td style={{ padding: "10px 16px", color: "#555" }}>{emp.position || "—"}</td>
                    <td style={{ padding: "10px 16px" }}>
                      {emp.ad_user_id ? (
                        <span className="badge badge-success">✓</span>
                      ) : emp.last_synced ? (
                        <span className="badge badge-danger">✗</span>
                      ) : (
                        <span className="badge badge-info" title="AD-Sync noch nicht ausgeführt">—</span>
                      )}
                    </td>
                    <td style={{ padding: "10px 16px" }}>
                      <span className={`badge badge-${emp.status === "active" ? "success" : "info"}`}>
                        {emp.status === "active" ? "Aktiv" : "Inaktiv"}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
